import { takeEvery, put, call, select } from "redux-saga/effects";

import * as action from "./actions";
import * as api from "../../apis";
import { message } from "antd";

// seconds
const MESSAGE_DURATION = 5;

import { user_id, currentUserIsInternal } from "../User/selectors";
import { currentMerchantName, currentMerchantId } from "../Merchant/selectors";

export function* getReports(request: any) {
  try {
    let response = yield call(api.fetchReports, request.payload);
    yield put(action.addReports(response));
  } catch (e) {
    yield put(action.getReportsFailure());
  }
}

export function* watchGetReports() {
  yield takeEvery(action.GET_REPORTS, getReports);
}

export function* deleteReport(request: any) {
  let { merchant_id, report_id, report_name } = request.payload;
  try {
    let userId = select(user_id);
    let Window = <any>window;
    let response = yield call(api.deleteReport, merchant_id, report_id);

    message.config({
      top: 70
    });
    message.success(
      `Your report named "${report_name}" has been successfully deleted`,
      MESSAGE_DURATION
    );

    yield put(action.getReports(merchant_id));

    const merchant_name = yield select(currentMerchantName, merchant_id);
    let internal = yield select(currentUserIsInternal);
    if (userId && merchant_name) {
      const company_type = internal ? "Internal" : "External";
      Window.ga(
        "send",
        "event",
        "Report Deleted - " + company_type,
        merchant_name,
        userId
      );
    }
  } catch (e) {
    console.log(e);
    yield put(action.deleteReportFailure());

    message.config({
      top: 70
    });
    message.error(
      `Your report named "${report_name}" failed to be deleted`,
      MESSAGE_DURATION
    );
  }
}

export function* watchDeleteReport() {
  yield takeEvery(action.DELETE_REPORT, deleteReport);
}

export function* getReportFiles(request: any) {
  try {
    let response = yield call(api.fetchFiles, request.payload);
    yield put(action.addReportFiles(response));
  } catch (e) {
    yield put(action.getReportFilesFailure());
  }
}

export function* watchGetReportFiles() {
  yield takeEvery(action.GET_REPORT_FILES, getReportFiles);
}

export function* selectMerchant(request: any) {
  let userId = yield select(user_id);
  let Window = <any>window;

  const merchant_name = yield select(
    currentMerchantName,
    request.payload.merchant_id
  );
  let internal = yield select(currentUserIsInternal);
  if (userId && merchant_name) {
    const company_type = internal ? "Internal" : "External";
    Window.ga(
      "send",
      "event",
      "MerchantSelection - " + company_type,
      merchant_name,
      userId
    );
  }
}

export function* watchSelectMerchant() {
  yield takeEvery(action.SELECT_MERCHANT, selectMerchant);
}

export function* resendReportFile(request: any) {
  try {
    let response = yield call(
      api.resendReport,
      request.payload.merchant_id,
      request.payload.report_id,
      request.payload.report_file_id,
      "dispatcher"
    );
    yield put(action.getReportFiles(request.payload.merchant_id));
    message.config({
      top: 70
    });
    message.success(
      `The system is attempting to resend your report named "${response.filename}" to the appropriate endpoints.`,
      MESSAGE_DURATION
    );
  } catch (e) {
    yield put(action.resendReportFileFailure());
  }
}

export function* watchResendReportFile() {
  yield takeEvery(action.RESEND_REPORT_FILE, resendReportFile);
}

export function* sendLatestReport(request: any) {
  let { merchant_id, report_id } = request.payload;
  try {
    let response = yield call(api.sendLatestReport, merchant_id, report_id);
    message.config({
      top: 70
    });
    message.success(
      `The system is attempting to send your report named "${response.name}" to the appropriate endpoints.`,
      MESSAGE_DURATION
    );
    yield put(action.getReportFiles(merchant_id));
  } catch (e) {
    console.log(e);
    yield put(action.sendLatestReportFailure());
    message.config({
      top: 70
    });
    message.error(`Your report failed to be sent.`, MESSAGE_DURATION);
  }
}

export function* watchSendLatestReport() {
  yield takeEvery(action.SEND_LATEST_REPORT, sendLatestReport);
}



// WEBPACK FOOTER //
// ./client/modules/Report/sagas.ts